export const CONFIG = [
  {
    value: '',
    label: '',
    prompt: '',
  },
  {
    value: 'improveWriting',
    label: 'Improve writing',
    prompt:
      'Improve the writing of this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'makeShorts',
    label: 'Make shorter',
    prompt:
      'Shorten this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'makeLonger',
    label: 'Make longer',
    prompt:
      'Expand and lengthen this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'simplifyLanguage',
    label: 'Simplify language',
    prompt:
      'Simplify the language of this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'summarize',
    label: 'Summarize',
    prompt:
      'Summarize this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'complete',
    label: 'Complete',
    prompt:
      'Complete the rest of this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
  {
    value: 'rewrite',
    label: 'Paraphrase',
    prompt:
      'Paraphrase this text while preserving all HTML tags. Do not add backticks or code blocks to your response: ',
  },
]
